import http from '../helpers/http';

const EmployeeDepartments = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async () => {
      const result = await http.get(`/employee-departments`, {
        headers,
      });
      return result.data;
    },
    create: async (body: { franchiseeId: string; name: string }) => {
      const result = await http.post(`/employee-departments`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/employee-departments/${id}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default EmployeeDepartments;
